import gsap from "gsap/gsap-core";
import React from "react";
import curation from "../webgl/data/curation";

import "./info-modal.css";

class InfoModal extends React.PureComponent {
  componentDidMount() {
    gsap.set(this.container, { autoAlpha: this.props.visible ? 1 : 0 });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.animate(this.props.visible);
    }
  }

  animate(visible) {
    gsap.to(this.container, {
      autoAlpha: visible ? 1 : 0,
      onComplete: () => {
        this.background.style.pointerEvents = visible ? "inherit" : "none";
      },
    });
  }

  onClose = () => {
    this.props.onClose();
  };

  renderArtists() {
    const list = [];
    for (let i = 0; i < curation.curation.artists.length; i++) {
      const artists = [];
      for (let j = 0; j < curation.curation.artists[i].artist.length; j++) {
        const artist = curation.curation.artists[i].artist[j];
        const profile = curation.curation.artists[i].profile[j];
        const space = j > 0 ? " & " : "";
        const url = `https://www.hicetnunc.xyz/tz/${profile}/creations`;
        artists.push(
          <>
            {space}
            <a
              key={j}
              target="_blank"
              rel="noreferrer"
              href={url}
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              {artist}
            </a>
          </>
        );
      }
      list.push(<li key={i}>{artists}</li>);
    }
    return <ul className="artists-list">{list}</ul>;
  }

  render() {
    const data = curation.curation;

    return (
      <div
        className="Modal-bg"
        ref={(node) => {
          this.background = node;
        }}
        onClick={this.onClose}
      >
        <div
          className="InfoModal"
          ref={(node) => {
            this.container = node;
          }}
        >
          <h1>{data.title}</h1>
          <h2>{data.subtitle}</h2>
          <p
            className="curated"
            dangerouslySetInnerHTML={{ __html: data.curated }}
          ></p>
          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: data.description }}
          ></p>
          <p className="artists">Artists</p>
          {this.renderArtists()}
          <button className="close" onClick={this.onClose}>
            X
          </button>
        </div>
      </div>
    );
  }
}

export default InfoModal;
